import React, { useState } from "react";
import '../../Components/Login-Components/Login.css';
import logo from '../../Assets/graduation-cap.jpg'
import { FiLock, FiEye, FiEyeOff, FiPhone } from 'react-icons/fi';
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Dashboard-Components/Footer";


function Login() {
    const navigate = useNavigate();

    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = (e) => {
        e.preventDefault();
        // You can add real login logic here
        // navigate('/get-started');
        const passwordRegex = /^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

        if (!/^\d{10}$/.test(mobile)) {
            setError("Mobile number must be exactly 10 digits.");
            return;
        }

        // if (!passwordRegex.test(password)) {
        //     setError("Password must be at least 8 characters and include a special character.");
        //     return;
        // }

        setError('');
        // Navigate to next page
        navigate('/get-started');
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="logo" className="login-image" />

                <h1 className="hello-text">Hello!</h1>
                <h2 className="welcome-heading">👋 Welcome Students</h2>


                {/* actual login page */}

                <form onSubmit={handleLogin}>
                    <div className="input-group">
                        <FiPhone className="icon" />
                        <input type="tel" placeholder="Mobile Number" required value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />

                    </div>

                    <div className="input-group">
                        <FiLock className="icon" />
                        <input type={showPassword ? 'text' : 'password'} placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required />

                        <div
                            className="toggle-icon"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FiEyeOff /> : <FiEye />}
                        </div>
                    </div>

                    {/* <small className="password-hint">
                        Password must be at least 8 characters and include a special character (e.g., @, #, !)
                    </small> */}

                    {error && <p className="error-text">{error}</p>}

                    <a href="#" className="forget-password">Forgot password?</a>

                    <button type="submit">Login</button>

                    {/* code for divider */}
                    {/* <div className="divider">
                        <span>or Login with</span>
                    </div>

                    <div className="social-login-icons">
                        <button className="icon-btn google">
                            <img
                                src="https://img.icons8.com/color/24/000000/google-logo.png"
                                alt="Google"
                            />
                        </button>

                        <button className="icon-btn facebook">
                            <img
                                src="https://img.icons8.com/ios-filled/24/ffffff/facebook-new.png"
                                alt="Facebook"
                            />
                        </button>
                        <button className="icon-btn github">
                            <img
                                src="https://img.icons8.com/ios-glyphs/24/000000/github.png"
                                alt="GitHub"
                            />
                        </button>

                        <button className="icon-btn apple">
                            <img
                                src="https://img.icons8.com/ios-filled/24/000000/mac-os.png"
                                alt="Apple"
                            />
                        </button>
                    </div> */}

                    <div className="signup-link">
                        <p>Don't have an account? <Link to="/signup">Sign up</Link>
                        </p>
                    </div>
                </form>

                {/* <footer className="login-footer">
                    <p>© 2025 YourCompany. Powered by YourTech</p>
                </footer> */}

                <div className="admin-login-link"> {/* ADDED */}
                    <p>
                        <Link to="/admin-login">Login as Administrator</Link>
                    </p>
                </div>
 {/* <Footer/> */}
            </div>
           
        </div>

    )
}
export default Login;

